import {HookClass, Hook, BaseHook, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import {from, Observable, of} from 'rxjs';
import {ArtfactKind} from '@mrp-brasil/nick-data-commons';
import {OpenAIApi, Configuration} from 'openai';
import {concatMap, map} from 'rxjs/operators';

@HookClass('ai.openai')
export class AiOpenaiHook extends BaseHook {

    @Hook('8496025f-3200-4d1e-8ab5-335243a134fb')
    public createCompletion(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.settings
            .pipe(concatMap((settings: any) => {
                const configuration = new Configuration({
                    apiKey: settings.openai.apiKey
                });

                const openai = new OpenAIApi(configuration);
                return from(openai.createCompletion({
                    model: inputArtifact.object.model ? inputArtifact.object.model : 'text-davinci-002',
                    prompt: inputArtifact.object.prompt,
                    temperature: inputArtifact.object.temperature,
                    max_tokens: inputArtifact.object.maxTokens ? inputArtifact.object.maxTokens : 6
                }))
                    .pipe(map((response: any) => {
                        const outputArtifact = new NickProcessArtfact();
                        outputArtifact.kind = ArtfactKind.ANY;
                        outputArtifact.object = response.data;
                        return outputArtifact;
                    }));
            }));
    }

    @Hook('ac6b677c-ef03-40f6-b064-e00bf7f2e91f')
    public createChatCompletion(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.settings
            .pipe(concatMap((settings: any) => {
                const configuration = new Configuration({
                    apiKey: settings.openai.apiKey
                });

                const openai = new OpenAIApi(configuration);
                return from(openai.createChatCompletion({
                    model: inputArtifact.object.model ? inputArtifact.object.model : 'text-davinci-003',
                    messages: inputArtifact.object.messages,
                    temperature: inputArtifact.object.temperature,
                    presence_penalty: inputArtifact.object.presence_penalty,
                    top_p: inputArtifact.object.top_p,
                    max_tokens: inputArtifact.object.maxTokens ? inputArtifact.object.maxTokens : 6
                }))
                    .pipe(map((response: any) => {
                        const outputArtifact = new NickProcessArtfact();
                        outputArtifact.kind = ArtfactKind.ANY;
                        outputArtifact.object = response.data;
                        return outputArtifact;
                    }));
            }));
    }
}
